const between = (min: number, max: number) => (
  Math.floor((Math.random() * (max - min)) + (1 + min))
);

const isNumber = (value: any) => (
  Number.isInteger(value) && !Number.isNaN(value)
);

const toOrdinal = (number: number) => {
  const b = number % 10;

  if (((number % 100) / 10) === 1) {
    return `${number}th`;
  }
  if (b === 1) {
    return `${number}st`;
  }
  if (b === 2) {
    return `${number}nd`;
  }
  if (b === 3) {
    return `${number}rd`;
  }

  return `${number}th`;
};

export {
  between,
  isNumber,
  toOrdinal,
};
